import { render } from "./CustomerRelationsForm.vue?vue&type=template&id=5ee17c45"
import script from "./CustomerRelationsForm.vue?vue&type=script&lang=js"
export * from "./CustomerRelationsForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__